var _defs, _path, _path2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrimLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1728.38 493.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e9c41e;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #231815;\n        font-family: 'Noto Sans KR', sans-serif;\n        font-size: 200px;\n        letter-spacing: -.05em;\n        stroke: #231815;\n        stroke-miterlimit: 10;\n        stroke-width: 8.4px;\n      }\n\n      .cls-2 {\n        fill: #727373;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346,492.07c-92.44-18.25-184.89,0-277.33-18.25C30.74,466.36,0,425.97,0,394.08v-228.93c0-31.87,30.74-52.8,68.67-57.19,92.44-8.95,184.89-54.4,277.33-63.35,37.92-4.4,68.67,36.16,68.67,80.14v309.73c0,43.96-30.74,65.06-68.67,57.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m397.14,462.08c-91.75-17.7-183.49,0-275.24-17.7-40.08-7.69-72.57-50.67-72.57-84.37V126.07c0-33.66,32.49-55.67,72.57-60.78C213.65,55.46,305.4,10.24,397.14.41c40.08-5.11,72.57,37.86,72.57,84.37v316.52c0,46.46-32.49,68.47-72.57,60.78Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(584.18 347.55) scale(1 1.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB4DC\uB9BC\uC885\uD569\uAC74\uC124"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrimLogo);
export default __webpack_public_path__ + "static/media/drim-logo.bffe9485c545f23d3d1f74a8a825b95b.svg";
export { ForwardRef as ReactComponent };